import { Flex } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { INSURER_DATA } from "./insurerData";

export type InsurerLogosProps = {
  insurers: string[];
  className?: string;
};

export const InsurerLogos = ({ insurers, className }: InsurerLogosProps) => {
  const classes = classNames("mobius", "mobius-insurer-logos", className);

  return (
    <Flex className={classes} data-testid="mobius-insurer-logos">
      {insurers.map(key => {
        const insurer = INSURER_DATA[key];
        if (!insurer) {
          console.warn(`Unknown insurer key: ${key}`);
          return null;
        }
        return (
          <img
            key={key}
            src={insurer.src}
            alt={insurer.alt}
            className="mobius-insurer-logos__logo"
            data-insurer={key}
            data-testid={`mobius-insurer-logos__logo--${key}`}
          />
        );
      })}
    </Flex>
  );
};

InsurerLogos.displayName = "InsurerLogos";
